import * as Sentry from '@sentry/react'
import {
  API_ERROR_EXCLUTIONS,
  SENTRY_ERROR_CAPTURE_STRING,
} from './sentry-messages'

export const captureError = (message: string, extra: any) => {
  // Skipping expected API errors
  if (API_ERROR_EXCLUTIONS.includes(extra?.error?.message)) {
    return
  }

  // Pass string version of error to avoid Scrubbing
  extra.errorString = JSON.stringify(extra.error || null)

  Sentry.captureMessage(message + SENTRY_ERROR_CAPTURE_STRING, {
    level: 'error',
    extra,
  })
}
